import React, { useRef } from 'react';
import { CountdownTimer } from '../components/buy-lotto/CountdownTimer';
import { SecondaryPrize } from '../components/buy-lotto/SecondaryPrize';
import { TicketPurchase } from '../components/buy-lotto/TicketPurchase';
import { HowItWorks } from '../components/buy-lotto/HowItWorks';

export function BuyLottoPage() {
  const ticketPurchaseRef = useRef(null);

  const handleBuyLotteryClick = () => {
    ticketPurchaseRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="space-y-6 sm:space-y-8">
      <CountdownTimer onBuyLotteryClick={handleBuyLotteryClick} />
      <SecondaryPrize />
      <TicketPurchase ticketPurchaseRef={ticketPurchaseRef} />
      <HowItWorks />
    </div>
  );
}
